"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _actionBlockModule = _interopRequireDefault(require("./action-block.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var calculateStyles = function calculateStyles() {
  var _ref2;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      error = _ref.error,
      disabled = _ref.disabled,
      className = _ref.className,
      mode = _ref.mode,
      dangerouslyForceHoverStyling = _ref.dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling = _ref.dangerouslyForceFocusStyling;

  return (0, _classnames["default"])([_actionBlockModule["default"]['action-block'], className, (_ref2 = {}, _defineProperty(_ref2, _actionBlockModule["default"].self, mode === 'self'), _defineProperty(_ref2, _actionBlockModule["default"].group, mode === 'group'), _defineProperty(_ref2, _actionBlockModule["default"].container, mode === 'container'), _defineProperty(_ref2, _actionBlockModule["default"]['force-hover'], dangerouslyForceHoverStyling), _defineProperty(_ref2, _actionBlockModule["default"]['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_ref2, _actionBlockModule["default"].error, error), _defineProperty(_ref2, _actionBlockModule["default"].disabled, disabled), _ref2)]);
};

var ActionBlock = _react["default"].forwardRef(function (props, ref) {
  var Component = props.component,
      children = props.children,
      className = props.className,
      error = props.error,
      disabled = props.disabled,
      mode = props.mode,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      otherProps = _objectWithoutProperties(props, ["component", "children", "className", "error", "disabled", "mode", "dangerouslyForceHoverStyling", "dangerouslyForceFocusStyling"]);

  return _react["default"].createElement(Component, _extends({
    className: calculateStyles({
      className: className,
      error: error,
      disabled: disabled,
      mode: mode,
      dangerouslyForceHoverStyling: dangerouslyForceHoverStyling,
      dangerouslyForceFocusStyling: dangerouslyForceFocusStyling
    })
    /**
     * This is forwarded to the underlying component so that disabling inputs
     * works as expected.
     */
    ,
    disabled: disabled,
    ref: ref
  }, otherProps), children);
});

ActionBlock.displayName = 'ActionBlock';

if (process.env.NODE_ENV !== 'production') {
  ActionBlock.propTypes = {
    /** Optional children to render inside the action block. */
    children: _propTypes["default"].node,

    /** The component that will be used to render the action block. */
    component: _propTypes["default"].elementType.isRequired,

    /** Additional classes to be added to the component. */
    className: _propTypes["default"].string,

    /** Show the component with error styles. */
    error: _propTypes["default"].bool,

    /** Show the component with disabled styles. */
    disabled: _propTypes["default"].bool,

    /**
     * Controls how CSS selectors for the focus state are implemented.
     *
     * For "self" mode, the element being rendered as the action block should
     * be focusable, such as with a text input.
     *
     * For "group" mode, the action block should immediately follow some element
     * that is focusable, such as a with a custom checkbox with a hidden input.
     *
     * For "container" mode, the action block should have an input as its child.
     */
    mode: _propTypes["default"].oneOf(['self', 'group', 'container']),

    /** Force the component to render with its hover styles. */
    dangerouslyForceHoverStyling: _propTypes["default"].bool,

    /** Force the component to render with its focus styles. */
    dangerouslyForceFocusStyling: _propTypes["default"].bool
  };
}

ActionBlock.defaultProps = {
  children: null,
  className: null,
  error: false,
  disabled: false,
  mode: 'self',
  dangerouslyForceHoverStyling: false,
  dangerouslyForceFocusStyling: false
};
var _default = ActionBlock;
exports["default"] = _default;